export enum InteractionName {
  APP_NAVIGATION_IN = 'app-navigation-in',
  APP_MOUNT = 'app-mount',
  MARK_CARD_AS_PRIMARY = 'mark-card-as-primary',
  DELETE_CARD = 'delete-card',
  LOAD_FREE_TEXTS = 'load-free-texts',
  LOAD_CARDS = 'load-cards',
  LOAD_ADD_PM_MODAL = 'load-add-pm-modal',
  LOAD_DELETE_CARD_MODAL = 'load-delete-card-modal',
  GET_SUBSCRIPTIONS_AMOUNT = 'get-subscriptions-amount',
}
